import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sticky CTA button that appears after scrolling
 * Hides on scroll up for better UX
 */
export const StickyCTA = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Show after scrolling 300px down
      if (currentScrollY > 300) {
        // Hide on scroll up, show on scroll down
        if (currentScrollY < lastScrollY) {
          setVisible(false);
        } else {
          setVisible(true);
        }
      } else {
        setVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const scrollToForm = () => {
    document.getElementById('form')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToForm}
      className={`fixed bottom-6 right-6 z-50 btn btn-primary shadow-lg transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'
      }`}
      aria-label={t('stickyCta')}
    >
      {t('stickyCta')}
    </button>
  );
};
